import { REQUEST_PAYMENT, REQUEST_PAYMENT_FAILURE, REQUEST_PAYMENT_SUCCESS } from "../../constant/DashboardConstant";

const initialState = {
  payment: {
    data: [],
  },
};

export const paymentReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case REQUEST_PAYMENT:
      return {
        ...state,
        payment: {
          data: [],
          status: 'fetching',
          isLoading: true,
        },
      };
    case REQUEST_PAYMENT_SUCCESS:
      return {
        ...state,
        payment: {
          data: payload,
          status: 'ready',
          isLoading: false,
        },
      };
    case REQUEST_PAYMENT_FAILURE:
      return {
        ...state,
        payment: {
          data: [],
          status: 'failure',
          isLoading: false,
        },
      };
    default:
      return state;
  }
}